"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificazioneDtoToJSON = exports.CertificazioneDtoFromJSONTyped = exports.CertificazioneDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function CertificazioneDtoFromJSON(json) {
    return CertificazioneDtoFromJSONTyped(json, false);
}
exports.CertificazioneDtoFromJSON = CertificazioneDtoFromJSON;
function CertificazioneDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'filialeNdg': !runtime_1.exists(json, 'filialeNdg') ? undefined : json['filialeNdg'],
        'idModalitaCertificazione': !runtime_1.exists(json, 'idModalitaCertificazione') ? undefined : json['idModalitaCertificazione'],
        'idStatoCertificazione': !runtime_1.exists(json, 'idStatoCertificazione') ? undefined : json['idStatoCertificazione'],
        'idWorkflowCertificazione': !runtime_1.exists(json, 'idWorkflowCertificazione') ? undefined : json['idWorkflowCertificazione'],
        'workFlowCertificazioneNome': !runtime_1.exists(json, 'workFlowCertificazioneNome') ? undefined : json['workFlowCertificazioneNome'],
        'modalitaCertificazioneDesc': !runtime_1.exists(json, 'modalitaCertificazioneDesc') ? undefined : json['modalitaCertificazioneDesc'],
        'statoCertificazioneDesc': !runtime_1.exists(json, 'statoCertificazioneDesc') ? undefined : json['statoCertificazioneDesc'],
        'matricolaOperatore': !runtime_1.exists(json, 'matricolaOperatore') ? undefined : json['matricolaOperatore'],
        'nominativoOperatore': !runtime_1.exists(json, 'nominativoOperatore') ? undefined : json['nominativoOperatore'],
        'filialeOperatore': !runtime_1.exists(json, 'filialeOperatore') ? undefined : json['filialeOperatore'],
        'tipoProfiloOperatore': !runtime_1.exists(json, 'tipoProfiloOperatore') ? undefined : json['tipoProfiloOperatore'],
        'emailAnagrafe': !runtime_1.exists(json, 'emailAnagrafe') ? undefined : json['emailAnagrafe'],
        'emailFirmaBiometricaAnagrafe': !runtime_1.exists(json, 'emailFirmaBiometricaAnagrafe') ? undefined : json['emailFirmaBiometricaAnagrafe'],
        'emailHomeBanking': !runtime_1.exists(json, 'emailHomeBanking') ? undefined : json['emailHomeBanking'],
        'cellulareAnagrafe': !runtime_1.exists(json, 'cellulareAnagrafe') ? undefined : json['cellulareAnagrafe'],
        'cellulareHomeBanking': !runtime_1.exists(json, 'cellulareHomeBanking') ? undefined : json['cellulareHomeBanking'],
        'motivazioneRichiestaCertificazione': !runtime_1.exists(json, 'motivazioneRichiestaCertificazione') ? undefined : json['motivazioneRichiestaCertificazione'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
        'dataUltimaModifica': !runtime_1.exists(json, 'dataUltimaModifica') ? undefined : (new Date(json['dataUltimaModifica'])),
        'dataCertificazione': !runtime_1.exists(json, 'dataCertificazione') ? undefined : (json['dataCertificazione'] === null ? null : new Date(json['dataCertificazione'])),
        'dataInserimentoAnagrafeCedacri': !runtime_1.exists(json, 'dataInserimentoAnagrafeCedacri') ? undefined : (json['dataInserimentoAnagrafeCedacri'] === null ? null : new Date(json['dataInserimentoAnagrafeCedacri'])),
        'isCertificazioneFromLotto': !runtime_1.exists(json, 'isCertificazioneFromLotto') ? undefined : json['isCertificazioneFromLotto'],
        'idLotto': !runtime_1.exists(json, 'idLotto') ? undefined : json['idLotto'],
    };
}
exports.CertificazioneDtoFromJSONTyped = CertificazioneDtoFromJSONTyped;
function CertificazioneDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'nominativo': value.nominativo,
        'ndg': value.ndg,
        'filialeNdg': value.filialeNdg,
        'idModalitaCertificazione': value.idModalitaCertificazione,
        'idStatoCertificazione': value.idStatoCertificazione,
        'idWorkflowCertificazione': value.idWorkflowCertificazione,
        'workFlowCertificazioneNome': value.workFlowCertificazioneNome,
        'modalitaCertificazioneDesc': value.modalitaCertificazioneDesc,
        'statoCertificazioneDesc': value.statoCertificazioneDesc,
        'matricolaOperatore': value.matricolaOperatore,
        'nominativoOperatore': value.nominativoOperatore,
        'filialeOperatore': value.filialeOperatore,
        'tipoProfiloOperatore': value.tipoProfiloOperatore,
        'emailAnagrafe': value.emailAnagrafe,
        'emailFirmaBiometricaAnagrafe': value.emailFirmaBiometricaAnagrafe,
        'emailHomeBanking': value.emailHomeBanking,
        'cellulareAnagrafe': value.cellulareAnagrafe,
        'cellulareHomeBanking': value.cellulareHomeBanking,
        'motivazioneRichiestaCertificazione': value.motivazioneRichiestaCertificazione,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
        'dataUltimaModifica': value.dataUltimaModifica === undefined ? undefined : (value.dataUltimaModifica.toISOString()),
        'dataCertificazione': value.dataCertificazione === undefined ? undefined : (value.dataCertificazione === null ? null : value.dataCertificazione.toISOString()),
        'dataInserimentoAnagrafeCedacri': value.dataInserimentoAnagrafeCedacri === undefined ? undefined : (value.dataInserimentoAnagrafeCedacri === null ? null : value.dataInserimentoAnagrafeCedacri.toISOString()),
        'isCertificazioneFromLotto': value.isCertificazioneFromLotto,
        'idLotto': value.idLotto,
    };
}
exports.CertificazioneDtoToJSON = CertificazioneDtoToJSON;
